import { getPropCacheMixin } from '../utils/private/cache.js'
export default getPropCacheMixin('$listeners', 'qListeners')
